import { ListReducer, mergeEntities } from '../store';
import { Message } from './message.model';

export const messageReducer: ListReducer<'messages'> = (state = {}, action) => {

  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload && action.payload.ref.path[0] === 'messages') {
        const { data, ref } = action.payload;
        const messages = data.messages.reduce((acc: any, message: any) => {
          acc[message.id] = message;
          return acc;
        }, {});
        return mergeEntities<'messages'>(state, messages, ref);
      }
    }
      return state;

    case 'API_POST':
    case 'API_POST_SUCCESS': {
      if (action.payload && action.payload.ref.path[0] === 'messages') {
        const { data: message, ref } = action.payload;
        return mergeEntities<'messages'>(state, { [message.id]: message }, ref);
      }
      return state;
    }

    /*case 'RECEIVED_MESSAGE_FROM_SOCKET': {
      const oldMessage = state[action.payload.thread_id].filter((
        (message: any) => ((
          message.client_message_id === action.payload.client_message_id
        ))
      ))[0] || {};
      const messageList: Array<any> = (state[action.payload.thread_id] || [])
        .filter((message: any) => (
          message.client_message_id !== action.payload.client_message_id
        ));
      messageList.push(Object.assign({}, oldMessage, action.payload));

      const threadId: any = action.payload.thread_id;
      let newThreads: any = {};
      newThreads[threadId] = messageList;
      return Object.assign({}, state, newThreads);
    }*/

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/message/message.reducer.ts